import { zergApi } from "@/service/zerg";

class DocumentarySettlementService {
    async getTravelOrdersPendignSettlement(params){
        try {
            const data = await zergApi.post('/operations/documentary-settlements/get', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getDocumentOrders(params){
        try {
            const data = await zergApi.post('/operations/documentary-settlements/get-document-orders', params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async approveDocuments(params){
        try {
            const data = await zergApi.post('/operations/documentary-settlements/approve-documents', params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new DocumentarySettlementService();